import { http, SuccessResponseV1 } from './http'

export type User = {
  mail: string
  user: string
  jobTitle: string
  name: string
  orgUnit: string
}

//
// GET: /api/v1/users
//
export type GetUsersSuccessResponseV1 = SuccessResponseV1<User[]>

export async function getUsersV1API() {
  const { data } = await http.get<GetUsersSuccessResponseV1>(`/v1/users`)
  return data
}

//
// POST: /api/v1/users
//
export interface PostUser extends User {
  password: string
  groupTag: string
}

// export type PostUser = User & {
//   password: string
// }

export type PostUsersSuccessResponseV1 = SuccessResponseV1<string>

export async function postUsersV1API(user: PostUser) {
  const result = await http.post<PostUsersSuccessResponseV1>(`/v1/users`, user)
  return result
}

//
// DELETE: /api/v1/users
//
export type DeleteUser = {
  users: string[]
}

export type DeleteUsersSuccessResponseV1 = SuccessResponseV1<string>

export async function deleteUsersV1API(user: DeleteUser) {
  const { data } = await http.delete<DeleteUsersSuccessResponseV1>(`/v1/users`, { data: user })
  return data
}
